import 'bootstrap';

require('./bootstrap');
require('jquery-ujs');

var TurboLinks = require('turbolinks');
TurboLinks.start();

require('./mp');
